import { createhttp } from 'lib/services/http';

export const accountV2Http = createhttp({ baseURL: '/rest-api/account/v2' });

export const getAccountV2Summary = (corpAcctNbr: string) =>
  accountV2Http.get('/account/summary/current', {
    headers: {
      'nextiva-context-corpAcctNumber': corpAcctNbr,
    },
  });
